export default [
    "PFPF",
    "PFF",
];
